<template>
  <!-- 合同详情：合同信息 + 明细 + 续费记录 + 收款记录 -->
  <div class="defaultViewStyle contract-detail">
    <list-page>
      <div class="detail-body">
        <list-table background-color="#FFF" :show-shadow="true">
          <form-tag label="合同信息"/>
          <form-items :data="dataDetail" :columns="3">
            <form-item label="合同编号">
              <strong>{{ dataDetail.contractNumber || "—" }}</strong>
            </form-item>
            <form-item label="合同名称">{{ dataDetail.contractName || "—" }}</form-item>
            <form-item label="合同类型">{{ contractTypeMap[dataDetail.contractType] || "—" }}</form-item>
            <form-item label="客户">{{ dataDetail.customerName || "—" }}</form-item>
            <form-item label="负责人(销售)">{{ dataDetail.salesName || "—" }}</form-item>
            <form-item label="售后人员">{{ dataDetail.supportName || "—" }}</form-item>
            <form-item label="客户联系人">{{ dataDetail.contactPerson || "—" }}</form-item>
            <form-item label="客户电话">{{ dataDetail.contactPhone || "—" }}</form-item>
            <form-item label="签约日期">{{ dateOnly(dataDetail.billDate) }}</form-item>
            <form-item label="合同到期日期">{{ dateOnly(dataDetail.expireDate) }}</form-item>
            <form-item label="合同金额(元)">{{ fmtMoney(dataDetail.amount) }}</form-item>
            <form-item label="已回款(元)">{{ fmtMoney(dataDetail.amountReceived) }}</form-item>
            <form-item label="回款进度">
              <el-progress :percentage="progress(dataDetail.receiptProgress)" :stroke-width="10"/>
            </form-item>
            <form-item label="状态">
              <el-tag size="small" :type="statusOf(dataDetail.contractStatus).type">{{ statusOf(dataDetail.contractStatus).text }}</el-tag>
            </form-item>
            <form-item label="备注" :col-span="3">{{ dataDetail.remark || '—' }}</form-item>
          </form-items>
        </list-table>

        <list-table background-color="#FFF" :show-shadow="true">
          <form-tag :label="'合同明细（' + itemList.length + ' 行）'"/>
          <yq-table :data="itemList" height="auto" page-name="contractItem" app-name="basedata">
            <yq-table-column label="产品" prop="productName" min-width="200rem" :show-overflow-tooltip="true">
              <template v-slot="{row}">{{ row.productName || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="产品线" prop="productLineName" min-width="120rem">
              <template v-slot="{row}">{{ row.productLineName || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="版本号" prop="version" min-width="120rem">
              <template v-slot="{row}">{{ row.version || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="用户数" prop="userCount" width="90rem" align="center">
              <template v-slot="{row}">{{ row.userCount || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="开始时间" prop="startDate" width="120rem" align="center">
              <template v-slot="{row}">{{ dateOnly(row.startDate) }}</template>
            </yq-table-column>
            <yq-table-column label="部署方式" prop="publishType" width="130rem" align="center">
              <template v-slot="{row}">{{ publishTypeText(row) }}</template>
            </yq-table-column>
            <yq-table-column label="到期时间" prop="expireDate" width="130rem" align="center">
              <template v-slot="{row}">
                <span v-if="row.expireDate"><strong>{{ dateOnly(row.expireDate) }}</strong></span>
                <span v-else class="muted">不过期</span>
              </template>
            </yq-table-column>
            <yq-table-column label="销售金额(元)" prop="amount" width="130rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.amount) }}</template>
            </yq-table-column>
            <yq-table-column label="成本金额(元)" prop="cost" width="130rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.cost) }}</template>
            </yq-table-column>
            <yq-table-column label="毛利(元)" prop="profit" width="120rem" align="right">
              <template v-slot="{row}">
                <span :style="{color: Number(row.profit) < 0 ? '#c0392b' : '#2e8b57'}">{{ fmtMoney(row.profit) }}</span>
              </template>
            </yq-table-column>
            <yq-table-column label="续费金额(元)" prop="renewAmount" width="130rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.renewAmount) }}</template>
            </yq-table-column>
            <yq-table-column label="续费成本(元)" prop="renewCost" width="130rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.renewCost) }}</template>
            </yq-table-column>
            <yq-table-column label="续费毛利(元)" prop="renewProfit" width="130rem" align="right">
              <template v-slot="{row}">
                <span :style="{color: Number(row.renewProfit) < 0 ? '#c0392b' : '#2e8b57'}">{{ fmtMoney(row.renewProfit) }}</span>
              </template>
            </yq-table-column>
            <yq-table-column label="续费次数" prop="renewTimes" width="90rem" align="center">
              <template v-slot="{row}">{{ row.renewTimes || 0 }}</template>
            </yq-table-column>
            <yq-table-column label="操作" prop="options" align="center" width="100rem">
              <template v-slot="{row}">
                <table-button v-if="row.expireDate" type="write" @click="openRenewDialog(row)">续费</table-button>
                <span v-else class="muted">—</span>
              </template>
            </yq-table-column>
          </yq-table>
        </list-table>

        <list-table background-color="#FFF" :show-shadow="true">
          <form-tag :label="'续费记录（' + renewLogList.length + ' 次）'"/>
          <yq-table :data="renewLogList" height="auto" page-name="contractRenewLog" app-name="basedata">
            <yq-table-column label="产品" prop="productName" min-width="180rem" :show-overflow-tooltip="true">
              <template v-slot="{row}">{{ row.productName || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="原到期" prop="fromDate" width="120rem" align="center">
              <template v-slot="{row}">{{ dateOnly(row.fromDate) }}</template>
            </yq-table-column>
            <yq-table-column label="新到期" prop="toDate" width="120rem" align="center">
              <template v-slot="{row}"><strong>{{ dateOnly(row.toDate) }}</strong></template>
            </yq-table-column>
            <yq-table-column label="续费金额(元)" prop="amount" width="120rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.amount) }}</template>
            </yq-table-column>
            <yq-table-column label="成本(元)" prop="cost" width="110rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.cost) }}</template>
            </yq-table-column>
            <yq-table-column label="毛利(元)" prop="profit" width="110rem" align="right">
              <template v-slot="{row}">
                <span :style="{color: Number(row.profit) < 0 ? '#c0392b' : '#2e8b57'}">{{ fmtMoney(row.profit) }}</span>
              </template>
            </yq-table-column>
            <yq-table-column label="操作人" prop="operatorName" width="110rem" align="center">
              <template v-slot="{row}">{{ row.operatorName || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="续费时间" prop="renewTime" width="160rem" align="center">
              <template v-slot="{row}">{{ dateTime(row.renewTime) }}</template>
            </yq-table-column>
          </yq-table>
        </list-table>

        <list-table background-color="#FFF" :show-shadow="true">
          <form-tag :label="'收款记录（' + amountList.length + ' 条）'"/>
          <yq-table :data="amountList" height="auto" page-name="contractAmount" app-name="basedata">
            <yq-table-column label="收款金额(元)" prop="amountReceived" min-width="130rem" align="right">
              <template v-slot="{row}">{{ fmtMoney(row.amountReceived) }}</template>
            </yq-table-column>
            <yq-table-column label="收款人" prop="receivedName" min-width="110rem" align="center">
              <template v-slot="{row}">{{ row.receivedName || "—" }}</template>
            </yq-table-column>
            <yq-table-column label="收款时间" prop="createdTime" min-width="160rem" align="center">
              <template v-slot="{row}">{{ dateTime(row.createdTime) }}</template>
            </yq-table-column>
            <yq-table-column label="备注" prop="remark" min-width="200rem" :show-overflow-tooltip="true">
              <template v-slot="{row}">{{ row.remark || "—" }}</template>
            </yq-table-column>
          </yq-table>
        </list-table>
      </div>
    </list-page>

    <form-page :show-page="false" :show-shadow="false">
      <page-button type="write" el-type="primary" @click="toEdit">编辑</page-button>
      <page-button type="write" el-type="success" @click="openReceiptDialog">收款</page-button>
      <page-button @click="goBack">返回</page-button>
    </form-page>

    <!-- 收款弹窗 -->
    <el-dialog v-model="showReceiptDialog" title="合同收款" dialog-width="1" :close-on-click-modal="false">
      <form-items :data="receiptForm" :columns="1">
        <form-item label="合同编号">{{ dataDetail.contractNumber || '—' }}</form-item>
        <form-item label="合同金额">{{ fmtMoney(dataDetail.amount) }} 元</form-item>
        <form-item label="本次收款金额" :required="true">
          <el-input-number v-model="receiptForm.amountReceived" :min="0" :precision="2" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="备注">
          <el-input v-model="receiptForm.remark" type="textarea" :rows="2" placeholder="备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showReceiptDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveReceipt">确定</page-button>
      </template>
    </el-dialog>

    <!-- 续费弹窗 -->
    <el-dialog v-model="showRenewDialog" title="合同明细续费" dialog-width="1" :close-on-click-modal="false">
      <form-items :data="renewForm" :columns="1">
        <form-item label="产品">{{ renewForm.productName || '—' }}</form-item>
        <form-item label="原到期时间">{{ renewForm.expireDate || '—' }}</form-item>
        <form-item label="续费年数">
          <el-input-number v-model="renewForm.years" :min="0" :step="1" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="续费月数">
          <el-input-number v-model="renewForm.months" :min="0" :step="1" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="续费后到期">{{ nextExpireDate }}</form-item>
        <form-item label="本次续费金额(元)">
          <el-input-number v-model="renewForm.amount" :min="0" :precision="2" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="本次续费成本(元)">
          <el-input-number v-model="renewForm.cost" :min="0" :precision="2" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="备注">
          <el-input v-model="renewForm.remark" type="textarea" :rows="2" placeholder="备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showRenewDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="doRenew">确认续费</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import contractApi from "@/api/dz-crm/partner/contractApi";

const CONTRACT_TYPE_MAP = {1: "框架协议", 2: "销售合同", 3: "代理协议", 4: "服务合同"};
const CONTRACT_STATUS_MAP = {
  0: {text: "草稿", type: "info"},
  100: {text: "执行中", type: "primary"},
  200: {text: "已完成", type: "success"},
  300: {text: "已逾期", type: "danger"},
};
const PRODUCT_TYPE_SOFTWARE = 5;

export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "ContractDetail",
  components: {
    TableButton, PageButton, FormItems, FormItem, FormTag, YqTable, YqTableColumn,
    FormPage, ListTable, ListPage,
  },
  data() {
    return {
      dataDetail: {},
      itemList: [],
      renewLogList: [],
      amountList: [],
      contractTypeMap: CONTRACT_TYPE_MAP,
      showReceiptDialog: false,
      receiptForm: {contractId: "", amountReceived: null, remark: ""},
      showRenewDialog: false,
      renewForm: {id: "", productName: "", expireDate: "", years: 1, months: 0, amount: null, cost: null, remark: ""},
    };
  },
  computed: {
    nextExpireDate() {
      const base = this.renewForm.expireDate;
      const total = (Number(this.renewForm.years) || 0) * 12 + (Number(this.renewForm.months) || 0);
      if (!base || total <= 0) return "—";
      const parts = String(base).split("-");
      if (parts.length !== 3) return "—";
      let y = Number(parts[0]);
      let m = Number(parts[1]) + total;
      const d = Number(parts[2]);
      y = y + Math.floor((m - 1) / 12);
      m = ((m - 1) % 12) + 1;
      const lastDay = new Date(y, m, 0).getDate();
      return `${y}-${String(m).padStart(2, "0")}-${String(Math.min(d, lastDay)).padStart(2, "0")}`;
    },
  },
  beforeRouteLeave(to, from, next) {
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) {
      this.findById();
    }
  },
  methods: {
    findById() {
      if (!this.route.query.id) return;
      contractApi.findById(this.route.query.id).then(res => {
        if (!res) return;
        this.dataDetail = res;
        this.itemList = res.itemList || [];
        this.renewLogList = res.renewLogList || [];
        this.amountList = res.amountList || [];
      });
    },
    toEdit() {
      this.router.push(`/contract/list/edit?id=${this.dataDetail.id}`);
    },
    openReceiptDialog() {
      this.receiptForm = {contractId: this.dataDetail.id, amountReceived: null, remark: ""};
      this.showReceiptDialog = true;
    },
    saveReceipt() {
      if (!this.receiptForm.amountReceived || Number(this.receiptForm.amountReceived) <= 0) {
        this.$message.error("请填写本次收款金额");
        return;
      }
      contractApi.receipt(this.receiptForm).then(() => {
        this.$message.success("收款成功");
        this.showReceiptDialog = false;
        this.findById();
      });
    },
    openRenewDialog(row) {
      this.renewForm = {
        id: row.id,
        productName: row.productName,
        expireDate: this.dateOnly(row.expireDate),
        years: 1,
        months: 0,
        amount: row.renewAmount,
        cost: row.renewCost,
        remark: "",
      };
      this.showRenewDialog = true;
    },
    doRenew() {
      const total = (Number(this.renewForm.years) || 0) * 12 + (Number(this.renewForm.months) || 0);
      if (total <= 0) {
        this.$message.error("续费时长至少 1 个月");
        return;
      }
      contractApi.renew({
        id: this.renewForm.id,
        years: this.renewForm.years || 0,
        months: this.renewForm.months || 0,
        amount: this.renewForm.amount,
        cost: this.renewForm.cost,
        remark: this.renewForm.remark,
      }).then(() => {
        this.$message.success("续费成功");
        this.showRenewDialog = false;
        this.findById();
      });
    },
    goBack() {
      this.router.go(-1);
    },
    statusOf(status) {
      return CONTRACT_STATUS_MAP[status] || {text: "—", type: "info"};
    },
    publishTypeText(row) {
      if (Number(row.productType) !== PRODUCT_TYPE_SOFTWARE) return "—";
      if (Number(row.publishType) === 1) return "云服务器部署";
      if (Number(row.publishType) === 2) return "本地部署";
      return "—";
    },
    progress(value) {
      const n = Number(value) || 0;
      return Math.max(0, Math.min(100, Math.round(n * 100) / 100));
    },
    fmtMoney(value) {
      if (value === null || value === undefined || value === "") return "—";
      return Number(value).toLocaleString("zh-CN", {minimumFractionDigits: 0, maximumFractionDigits: 2});
    },
    dateOnly(value) {
      return value ? String(value).slice(0, 10) : "—";
    },
    dateTime(value) {
      return value ? String(value).slice(0, 19).replace("T", " ") : "—";
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-detail {
  .detail-body {
    padding: 0 10px;
    box-sizing: border-box;
  }
  .muted {
    color: #909399;
  }
}
</style>
